/* eslint-disable no-use-before-define */
import React from 'react'
import { arrayFrom, parseHtml, parseDate, sortFn, getId, show, fmt } from '../../twd'
import { useOrderTicket, MODES } from '../use-order-ticket'

export const SelectHolding = () => {

    const {
        positions, mode, cusip, setCusip, acctNo, actionSubset_
    } = useOrderTicket()

    const rs = arrayFrom(positions)
        .filter(({maturity}) => {
            const isMatured = parseDate(maturity) < Date.now()
            return !isMatured
        })
        .sort(sortFn(({issue, maturity}) => {
            return (issue || '').trim() + fmt.fmtDt(parseDate(maturity), 'yyyy-MM-dd')
        }))
    const isDisabled = rs.length===0

    const id = getId()

    return <div className="from-group"
            style={{paddingLeft:'0px', paddingRight:'0px'}}
        >
            <label className="label" htmlFor={id}>Choose from existing holdings</label>
            <div className="select-wrapper">
            <select
                id={id}
                data-name="order-ticket-select-holdings"
                defaultValue={cusip || ''}
                disabled={isDisabled}
                aria-disabled={isDisabled}
                onChange={(e) => {
                    const newCusip = e.target.value
                    if (!newCusip) return

                    const isRqt = mode === MODES.RFQ
                    const act = isRqt ? 'W' : 'S'
                    const isBuySell = act==='S'

                    setCusip(newCusip)
                    setTimeout(() => {
                        show('order-ticket', {
                            acctNo,
                            cusip: newCusip,
                            action: act,
                            actionSubset: isBuySell ? '' : actionSubset_,
                            ts: Date.now(),
                        })

                    })
                }}
                className="form-control text-truncate"
                style={{paddingRight:'25px'}}
            >
            { rs.length>0 && [{cusip:'', issue:'Select'}].concat(rs).map( (a,i) => {
                return <option
                    data-name="order-ticket-select-holdings-option"
                    key={i}
                    value={a.cusip || ''}
                    selected={a.cusip === cusip}
                    >{parseHtml(a.issue || '')}</option>
            })}
            </select>
            </div>
        </div>

}


// WEBPACK FOOTER //
// ./src/order-ticket/form/select-holding.js